import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const fields = document.getElementById("dispute-fields")
    if (event.target.checked) {
      fields.classList.remove("hidden")
    } else {
      fields.classList.add("hidden")
    }
  }
}
